import React from 'react';
import MealDetails from 'components/meal-content/meal-details';

const NewMealDetails = () => {
  return (
    <div>
      <MealDetails />
    </div>
  );
};

export default NewMealDetails;
